// extracted by mini-css-extract-plugin
export default {"main":"main-layout_main__nE6mH"};